import api from "./api.js";

export default class ConsultingApi {
  static async get(data) {
    return await api.get(`consulting-merch`, data);
  }
  static async getById(id, data) {
    return await api.get(`consulting-merch/${id}`, data);
  }
  static async add(data) {
    return await api.post(`consulting-merch`, data);
  }
  static async delete(data) {
    return await api.del(`consulting-merch`, data);
  }
  static async activation(id, data) {
    return await api.patch(`consulting-merch/activation/${id}`, data);
  }
  static async edit(id, data) {
    return await api.patch(`consulting-merch/${id}`, data);
  }
  // static async getPriorForm(data) {
  //   return await api.get(`consulting-merch`, data);
  // }

  static async getStudentList(data) {
    return await api.get(`member-lecture`, data);
  }
  static async getPriorFormList(data) {
    return await api.get(`consulting`, data);
  }
  static async getByPriorFormId(id, data) {
    return await api.get(`consulting/${id}`, data);
  }
  static async deleteConsulting(data) {
    return await api.del(`consulting`, data);
  }
  static async updateAnswer(consultingId, data) {
      return await api.patch(`consulting/answer/${consultingId}`, data);
    }
}
